'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { m } from 'framer-motion';
import { useBoolean } from 'minimal-shared/hooks';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useRouter } from 'src/routes/hooks';
import { paths, newSearchParams } from 'src/routes/paths';
import { useTranslate } from 'src/locales';
import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';
import { Scrollbar } from 'src/components/scrollbar';
import { CustomTabs } from 'src/components/custom-tabs';
import { ButtonLoadMore } from 'src/components/custom-buttons';
import { useNotificationsContext } from 'src/components/notifications';
import { varTap, varHover, transitionTap } from 'src/components/animate';
import { NotificationItem } from './notification-item';

// ----------------------------------------------------------------------

export function NotificationsDrawer(t0) {
  const $ = _c(95);
  let onCloseAccountDrawer;
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      onCloseAccountDrawer,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = onCloseAccountDrawer;
    $[2] = other;
    $[3] = sx;
  } else {
    onCloseAccountDrawer = $[1];
    other = $[2];
    sx = $[3];
  }
  const router = useRouter();
  const {
    t,
    currentLang
  } = useTranslate();
  const [currentTab, setCurrentTab] = useState("all");
  const {
    value: open,
    onFalse: onClose,
    onTrue: onOpen
  } = useBoolean();
  const {
    disabled,
    loadingMore,
    totalUnRead,
    allNotifications,
    handleMarkAsRead,
    totalNotifications,
    handleMarkAllAsRead,
    unreadNotifications,
    loadMoreNotifications
  } = useNotificationsContext();
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== allNotifications || $[5] !== currentLang.countryName || $[6] !== currentTab || $[7] !== disabled || $[8] !== handleMarkAllAsRead || $[9] !== handleMarkAsRead || $[10] !== onClose || $[11] !== onCloseAccountDrawer || $[12] !== onOpen || $[13] !== open || $[14] !== other || $[15] !== router || $[16] !== sx || $[17] !== t || $[18] !== totalNotifications || $[19] !== totalUnRead || $[20] !== unreadNotifications) {
    const TABS = [{
      value: "all",
      label: "All",
      count: totalNotifications
    }, {
      value: "unread",
      label: "Unread",
      count: totalUnRead
    }];
    let t13;
    if ($[34] !== currentLang.countryName || $[35] !== onClose || $[36] !== onCloseAccountDrawer || $[37] !== router) {
      t13 = () => {
        onClose();
        onCloseAccountDrawer?.();
        router.push(`${paths.user.account}${newSearchParams({
          country: currentLang.countryName,
          tab: "notifications"
        })}`);
      };
      $[34] = currentLang.countryName;
      $[35] = onClose;
      $[36] = onCloseAccountDrawer;
      $[37] = router;
      $[38] = t13;
    } else {
      t13 = $[38];
    }
    const handleOnClick = t13;
    let t14;
    if ($[39] !== handleMarkAllAsRead || $[40] !== handleOnClick || $[41] !== onClose || $[42] !== t || $[43] !== totalUnRead) {
      t14 = () => <Box sx={{
        py: 2,
        pl: 2.5,
        pr: 1.5,
        gap: 1,
        minHeight: 68,
        display: "flex",
        alignItems: "center"
      }}><Box sx={{
          flexGrow: 1,
          typography: "h6"
        }}>{t("Notifications")}</Box><Tooltip title={t(totalUnRead ? "Mark all as read" : "All read")}><IconButton color={totalUnRead ? "inherit" : "info"} onClick={() => totalUnRead && handleMarkAllAsRead} sx={{
            color: totalUnRead ? "text.disabled" : "info.main"
          }}><Iconify icon="eva:done-all-fill" /></IconButton></Tooltip><IconButton onClick={handleOnClick}><Iconify icon="solar:settings-bold-duotone" /></IconButton><IconButton onClick={onClose}><Iconify icon="mingcute:close-line" /></IconButton></Box>;
      $[39] = handleMarkAllAsRead;
      $[40] = handleOnClick;
      $[41] = onClose;
      $[42] = t;
      $[43] = totalUnRead;
      $[44] = t14;
    } else {
      t14 = $[44];
    }
    const renderHead = t14;
    const renderTabs = () => <CustomTabs value={currentTab} variant="fullWidth" onChange={(event, newValue) => setCurrentTab(newValue)}>{TABS.map(tab => <Tab key={tab.value} value={tab.value} iconPosition="end" label={t(tab.label)} icon={<Label variant={tab.value === "all" || tab.value === currentTab ? "filled" : "soft"} color={tab.value === "unread" ? "primary" : "default"}>{tab.count}</Label>} />)}</CustomTabs>;
    let t15;
    if ($[45] !== allNotifications || $[46] !== currentTab || $[47] !== handleMarkAsRead || $[48] !== unreadNotifications) {
      t15 = () => <Scrollbar><Box component="ul">{allNotifications?.map(notification => <Box component="li" key={notification.id} sx={{
            ...(currentTab === "unread" && {
              height: 0,
              overflow: "hidden"
            })
          }}><NotificationItem collection="all" notification={notification} handleMarkAsRead={handleMarkAsRead} /></Box>)}{unreadNotifications?.map(notification_0 => <Box component="li" key={notification_0.id} sx={{
            ...(currentTab === "all" && {
              height: 0,
              overflow: "hidden"
            })
          }}><NotificationItem collection="unread" notification={notification_0} handleMarkAsRead={handleMarkAsRead} /></Box>)}</Box></Scrollbar>;
      $[45] = allNotifications;
      $[46] = currentTab;
      $[47] = handleMarkAsRead;
      $[48] = unreadNotifications;
      $[49] = t15;
    } else {
      t15 = $[49];
    }
    const renderList = t15;
    let t16;
    let t17;
    let t18;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = varTap(0.96);
      t17 = varHover(1.04);
      t18 = transitionTap();
      $[50] = t16;
      $[51] = t17;
      $[52] = t18;
    } else {
      t16 = $[50];
      t17 = $[51];
      t18 = $[52];
    }
    let t19;
    if ($[53] !== sx) {
      t19 = Array.isArray(sx) ? sx : [sx];
      $[53] = sx;
      $[54] = t19;
    } else {
      t19 = $[54];
    }
    let t20;
    if ($[55] !== t19) {
      t20 = [...t19];
      $[55] = t19;
      $[56] = t20;
    } else {
      t20 = $[56];
    }
    let t21;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <Iconify icon="solar:bell-bing-bold-duotone" width={24} />;
      $[57] = t21;
    } else {
      t21 = $[57];
    }
    let t22;
    if ($[58] !== totalUnRead) {
      t22 = <Badge badgeContent={totalUnRead} color="error">{t21}</Badge>;
      $[58] = totalUnRead;
      $[59] = t22;
    } else {
      t22 = $[59];
    }
    if ($[60] !== disabled || $[61] !== onOpen || $[62] !== other || $[63] !== t20 || $[64] !== t22) {
      t11 = <IconButton onClick={onOpen} disabled={disabled} component={m.button} whileTap={t16} whileHover={t17} transition={t18} aria-label="Notifications button" sx={t20} {...other}>{t22}</IconButton>;
      $[60] = disabled;
      $[61] = onOpen;
      $[62] = other;
      $[63] = t20;
      $[64] = t22;
      $[65] = t11;
    } else {
      t11 = $[65];
    }
    T0 = SwipeableDrawer;
    t1 = open;
    t2 = "right";
    t3 = onOpen;
    t4 = true;
    t5 = onClose;
    t6 = true;
    t7 = true;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        paper: {
          sx: {
            width: {
              xs: 1,
              md: 370
            }
          }
        }
      };
      $[66] = t8;
    } else {
      t8 = $[66];
    }
    if ($[67] !== renderHead) {
      t9 = renderHead();
      $[67] = renderHead;
      $[68] = t9;
    } else {
      t9 = $[68];
    }
    t10 = renderTabs();
    t12 = renderList();
    $[4] = allNotifications;
    $[5] = currentLang.countryName;
    $[6] = currentTab;
    $[7] = disabled;
    $[8] = handleMarkAllAsRead;
    $[9] = handleMarkAsRead;
    $[10] = onClose;
    $[11] = onCloseAccountDrawer;
    $[12] = onOpen;
    $[13] = open;
    $[14] = other;
    $[15] = router;
    $[16] = sx;
    $[17] = t;
    $[18] = totalNotifications;
    $[19] = totalUnRead;
    $[20] = unreadNotifications;
    $[21] = T0;
    $[22] = t1;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    T0 = $[21];
    t1 = $[22];
    t10 = $[23];
    t11 = $[24];
    t12 = $[25];
    t2 = $[26];
    t3 = $[27];
    t4 = $[28];
    t5 = $[29];
    t6 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  let t13;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      p: 2
    };
    $[69] = t13;
  } else {
    t13 = $[69];
  }
  let t14;
  if ($[70] !== currentTab || $[71] !== loadMoreNotifications) {
    t14 = () => loadMoreNotifications(currentTab);
    $[70] = currentTab;
    $[71] = loadMoreNotifications;
    $[72] = t14;
  } else {
    t14 = $[72];
  }
  const t15 = currentTab === "all" ? totalNotifications : totalUnRead;
  const t16 = currentTab === "all" ? allNotifications.length : unreadNotifications.length;
  let t17;
  if ($[73] !== loadingMore || $[74] !== t14 || $[75] !== t15 || $[76] !== t16) {
    t17 = <Box sx={t13}><ButtonLoadMore perPage={10} loading={loadingMore} onClick={t14} total={t15} index={t16} /></Box>;
    $[73] = loadingMore;
    $[74] = t14;
    $[75] = t15;
    $[76] = t16;
    $[77] = t17;
  } else {
    t17 = $[77];
  }
  let t18;
  if ($[78] !== T0 || $[79] !== t1 || $[80] !== t10 || $[81] !== t12 || $[82] !== t17 || $[83] !== t2 || $[84] !== t3 || $[85] !== t4 || $[86] !== t5 || $[87] !== t6 || $[88] !== t7 || $[89] !== t8 || $[90] !== t9) {
    t18 = <T0 open={t1} anchor={t2} onOpen={t3} disableDiscovery={t4} onClose={t5} disableSwipeToOpen={t6} disableBackdropTransition={t7} slotProps={t8}>{t9}{t10}{t12}{t17}</T0>;
    $[78] = T0;
    $[79] = t1;
    $[80] = t10;
    $[81] = t12;
    $[82] = t17;
    $[83] = t2;
    $[84] = t3;
    $[85] = t4;
    $[86] = t5;
    $[87] = t6;
    $[88] = t7;
    $[89] = t8;
    $[90] = t9;
    $[91] = t18;
  } else {
    t18 = $[91];
  }
  let t19;
  if ($[92] !== t11 || $[93] !== t18) {
    t19 = <>{t11}{t18}</>;
    $[92] = t11;
    $[93] = t18;
    $[94] = t19;
  } else {
    t19 = $[94];
  }
  return t19;
}